import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import PageHeader from "../../components/PageHeader/PageHeader";
import { Row as Brow, Col as Bcol } from "reactstrap";
import {
  Button,
  Form,
  Table,
  Spin,
  Input,
  Select,
  Upload,
  Popconfirm,
  Tag,
  InputNumber,
  Space,
  DatePicker,
  message,
} from "antd";
import moment from "moment";
import { ReadCookie } from "../../utils/readCookie";
import numeral from "numeral";
import { CSVLink } from "react-csv";
import { TabTitle } from "../../utils/GeneralFunction";
import { searchProduct } from "../../redux/actions/searchProduct.action";
import { sendProduct } from "../../redux/actions/sendProductToBergen.action";
import notification from "../../utils/notification";
import {
  SearchOutlined,
  FilterFilled,
  UploadOutlined,
  PaperClipOutlined,
  DeleteOutlined,
  EditOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import Swal from "sweetalert2";
import { getVendors } from "../../redux/actions/vendor.action";
import {
  deleteExpenseBillAttachments,
  getAllExpenseBillAttachments,
  updateExpenseBillAttachments,
  uploadExpenseBillAttachments,
} from "../../redux/actions/expenseBill.action";
import axios from "axios";
import { BASEURL } from "../../constant/config";
import * as XLSX from "xlsx/xlsx.mjs";

const { Option } = Select;

const PendingBillPayment = () => {
  TabTitle("Pending Bill Payment");
  const [form] = Form.useForm();
  const [minimize, setMinimize] = useState(false);
  const dispatch = useDispatch();
  const token = ReadCookie("token");

  // Loading States
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [savingId, setSavingId] = useState(null); // Row-level save loading

  const [data, setData] = useState([]);
  const [isedit, setIsEdit] = useState(false);

  const tableRef = useRef(null);
  const { controlLog, vendor } = useSelector((state) => state);


  const [billStatus, setBillStatus] = useState("UNPAID");


  console.log("data", data);

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Bill Header #",
      dataIndex: "bill_header_no",
      key: "bill_header_no",
      render: (text, record) => (
        <span
          style={{
            color: "#1677ff",
            cursor: "pointer",
            textDecoration: "underline",
          }}
          onClick={() => {
            window.open(
              `/bill/edit/${record.bill_header_id}?edit=yes`,
              "_blank"
            );
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Bill Reference #",
      dataIndex: "bill_reference_no",
      key: "bill_reference_no",
    },
    // {
    //   title: "Vendor ID",
    //   dataIndex: "vendor_id",
    //   key: "vendor_id",
    // },
    {
      title: "Vendor Name",
      dataIndex: "vendor_name",
      key: "vendor_name",
    },
     {
      title: "Bill Amount",
      dataIndex: "bill_amount",
      key: "bill_amount",
      render: (text, record) => record.bill_amount ?? null,
    },

       {
      title: "Approval Amount",
      dataIndex: "approval_amount",
      key: "approval_amount",
      render: (text, record) =>
        record.is_edit ? (
          <InputNumber
            value={record.approval_amount ?? null}
            min={0}
            step={0.01}
            precision={2}
            style={{ width: "100%" }}
            onChange={(value) => {
              setData((prev) =>
                prev.map((item) =>
                  item.bill_header_id === record.bill_header_id
                    ? {
                      ...item,
                      approval_amount: value,
                    }
                    : item
                )
              );
            }}
          />
        ) : (
          text
        ),
    },

    {
      title: "Amount Paid",
      dataIndex: "amount_paid",
      key: "amount_paid",
      render: (text, record) => record.amount_paid ?? null,
    },

    {
      title: "Balance Amount",
      dataIndex: "balance_amount",
      key: "balance_amount",
      render: (text, record) => record.balance_amount ?? null,
    },

    {
      title: "PK Comment",
      dataIndex: "pk_comment",
      key: "pk_comment",
      render: (text, record) =>
        record.is_edit ? (
          <Input
            value={record.pk_comment ?? null}
            style={{ width: "100%" }}
            onChange={(e) => {
              setData((prev) =>
                prev.map((item) =>
                  item.bill_header_id === record.bill_header_id
                    ? {
                      ...item,
                      pk_comment: e.target.value,
                    }
                    : item
                )
              );
            }}
          />
        ) : (
          text
        ),
    },
    {
      title: "US Comment",
      dataIndex: "us_comment",
      key: "us_comment",
      render: (text, record) =>
        record.is_edit ? (
          <Input
            value={record.us_comment ?? null}
            style={{ width: "100%" }}
            onChange={(e) => {
              setData((prev) =>
                prev.map((item) =>
                  item.bill_header_id === record.bill_header_id
                    ? {
                      ...item,
                      us_comment: e.target.value,
                    }
                    : item
                )
              );
            }}
          />
        ) : (
          text
        ),
    },

    
    {
      title: "Bill Status",
      dataIndex: "billstatus",
      key: "billstatus",
      render: (text, record) => {
        return <Tag color={record.billstatus === "PAID" ? "green" : "red"}>{record.billstatus}</Tag>;
      },
    },

    {
      title: "Due Date",
      dataIndex: "due_date",
      key: "due_date",
      render: (text, record) =>
        record.is_edit ? (
          <DatePicker
            size="small"
            format="MM-DD-YYYY"
            value={record.due_date ? moment(record.due_date) : null}
            onChange={(value) => {
              if (value) {
                setData((prev) =>
                  prev.map((item) =>
                    item.vendor_communication_id ===
                      record.vendor_communication_id
                      ? {
                        ...item,
                        due_date: value,
                      }
                      : item
                  )
                );
              }
            }}
            style={{ width: "100%" }}
          />
        ) : text ? (
          moment(text).format("MM-DD-YYYY")
        ) : (
          "-"
        ),
    },
    
   
    
   
    
    {
      title: "Action",
      dataIndex: "",
      key: "action",
      render: (url, record) => (
        <Space>
          {record?.is_edit ? (
            <Popconfirm
              title="Are you sure you want to update this Bill?"
              onConfirm={async () => {
                let payload = {
                  due_date: moment(record.due_date).format("MM-DD-YYYY"),
                  us_comment: record.us_comment ?? null,
                  pk_comment: record.pk_comment ?? null,
                  approval_amount: record.approval_amount ?? null,
                };

                try {
                  setSavingId(record.bill_header_id);
                  const response = await axios({
                    method: "PUT",
                    url: `${BASEURL}update/pendingBillExpense/${record.bill_header_id}`,
                    headers: {
                      Accept: "application/json",
                      Authorization: "Bearer " + token,
                    },
                    data: payload,
                  });

                  if (response?.status === 200) {
                    message.success(
                      response?.data?.data || "Bill Updated successfully!"
                    );
                    setIsEdit(false);
                    await fetchPendingBillExpense(token);
                  }
                } catch (error) {
                  console.error(
                    "Error updating pending bill:",
                    error?.response?.data || error?.message
                  );
                  message.error(
                    error?.response?.data?.message ||
                    "Failed to update pending bill."
                  );
                } finally {
                  setSavingId(null);
                }
              }}
              okText="Yes"
              cancelText="No"
            >
              <Button
                type="primary"
                size="small"
                loading={savingId === record.bill_header_id}
              >
                Save
              </Button>
            </Popconfirm>
          ) : (
            <EditOutlined
              style={{
                color: "#1677ff",
                cursor: "pointer",
                marginLeft: "10px",
              }}
              onClick={() => {
                let copyArr = [...data];
                copyArr.forEach((item) => {
                  if (item.bill_header_id === record.bill_header_id) {
                    item.is_edit = true;
                  }
                });
                setData(copyArr);
              }}
            />
          )}
        </Space>
      ),
    },
  ];




  const formattedData = data.map((v) => ({
    "Bill Header ID": v.bill_header_id,
    "Bill Header No": v.bill_header_no,
    "Bill Reference No": v.bill_reference_no,
    // "Vendor ID": v.vendor_id,
    "Vendor Name": v.vendor_name,
    "Bill Amount": v.bill_amount,
    "Approval Amount": v.approval_amount,
    "Amount Paid": v.amount_paid,
    "Balance Amount": v.balance_amount,
    "PK Comment": v.pk_comment,
    "US Comment": v.us_comment,
    "Bill Status": v.billstatus,
    "Due Date": v.due_date ? moment(v.due_date).format("MM-DD-YYYY") : "-",
  }));

  const handleFileUpload = async (file) => {
    setUploading(true);
    try {
      const dataBuffer = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(new Uint8Array(e.target.result));
        reader.onerror = (err) => reject(err);
        reader.readAsArrayBuffer(file);
      });

      const workbook = XLSX.read(dataBuffer, { type: "array" });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];

      const parsedJson = XLSX.utils.sheet_to_json(worksheet, {
        defval: "",
      });

      const originalMap = new Map(
        data.map((item) => [String(item.bill_header_id), item])
      );

      const modifiedRows = [];

      parsedJson.forEach((row) => {
        const billId = String(row["Bill Header ID"] ?? "").trim();
        const originalItem = originalMap.get(billId);

        if (originalItem) {
          const newApprovalAmount =
            row["Approval Amount"] !== "" ? Number(row["Approval Amount"]) : 0;
          const newPkComment = String(row["PK Comment"] || "").trim();
          const newUsComment = String(row["US Comment"] || "").trim();

          const oldApprovalAmount = Number(originalItem.approval_amount || 0);
          const oldPkComment = String(originalItem.pk_comment || "").trim();
          const oldUsComment = String(originalItem.us_comment || "").trim();

          const isChanged =
            newApprovalAmount !== oldApprovalAmount ||
            newPkComment !== oldPkComment ||
            newUsComment !== oldUsComment;

          if (isChanged) {
            modifiedRows.push({
              bill_header_id: originalItem.bill_header_id,
              approval_amount: newApprovalAmount,
              pk_comment: newPkComment,
              us_comment: newUsComment,
            });
          }
        }
      });

      if (modifiedRows.length === 0) {
        message.info("No changes detected in the uploaded file.");
        setUploading(false);
        return false;
      }

      const response = await axios({
        method: "PUT",
        url: `${BASEURL}update/bulkPendingBillExpense/1`,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
        data: modifiedRows,
      });

      if (response?.status === 200) {

        await fetchPendingBillExpense(token);
        message.success(
          `${modifiedRows.length} record(s) modified successfully!`
        );
      }
    } catch (err) {
      console.error("Upload error:", err);
      message.error("Failed to parse or upload file. Please check file format.");
    } finally {
      setUploading(false);
    }

    return false;
  };

  const fetchPendingBillExpense = async (token, billStatus = null) => {
    setLoading(true);
    try {
      const response = await axios({
        method: "POST",
        url: `${BASEURL}getAll/pendingBillExpense`,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
        data: {
          bill_status: billStatus,
        },
      });

      if (response?.data?.data) {
        setData(response.data.data);
      }
    } catch (error) {
      console.error(
        "Error fetching pending bill expenses:",
        error?.response?.data || error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPendingBillExpense(token, billStatus);
  }, [token, billStatus]);

  return (
    <div className="styleContainer">
      <div className="styleBody h-100">
        <PageHeader
          title={"Pending Bill Payment"}
          minimize={setMinimize}
          check={minimize}
        />
      </div>

      <div style={{ marginTop: 10 }}>
        {loading ? (
          <div className="report-wrapper-main d-flex align-items-center justify-content-center spin-style mt-5 mb-5">
            <Spin size="large" tip="Loading Pending Bills..." />
          </div>
        ) : data.length > 0 ? (
          <>
            <Select defaultValue="UNPAID" placeholder="Select Bill Status" onChange={(value) => {
              setBillStatus(value);
              dispatch(fetchPendingBillExpense(token, value)).then((res) => {
                setData(res?.payload?.data);
              })
            }}>
              <Select.Option value={null}>ALL</Select.Option>
              <Select.Option value="PAID">PAID</Select.Option>
              <Select.Option value="UNPAID">UNPAID</Select.Option>
            </Select>
            <Table
              title={() => (
                <div
                  style={{
                    display: "flex",
                    gap: "12px",
                    alignItems: "center",
                  }}
                >
                  <Button type="primary">
                    <CSVLink
                      filename={"Pending Bill Payment.csv"}
                      data={formattedData}
                      style={{ color: "inherit", textDecoration: "none" }}
                    >
                      Download Excel
                    </CSVLink>
                  </Button>

                  <Upload
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    beforeUpload={handleFileUpload}
                    showUploadList={false}
                  >
                    <Button
                      icon={uploading ? <LoadingOutlined /> : <UploadOutlined />}
                      loading={uploading}
                    >
                      {uploading ? "Uploading..." : "Upload File"}
                    </Button>
                  </Upload>
                </div>
              )}
              ref={tableRef}
              size="small"
              bordered={false}
              type="company"
              perPage={15}
              scroll={{ x: "max-content" }}
              dataSource={data}
              columns={columns}
              loading={loading}
              rowKey="bill_header_id"
              onRow={(record) => {
                const today = moment().startOf("day");
                const dueDate = record.due_date
                  ? moment(record.due_date).startOf("day")
                  : null;

                const isPastDue = dueDate && dueDate.isBefore(today);
                const isUnpaid = record.billstatus === "UNPAID";

                return {
                  style: {
                    backgroundColor:
                      isPastDue && isUnpaid ? "#ffccc7" : "transparent",
                  },
                };
              }}
              pagination={{
                defaultCurrent: 1,
                defaultPageSize: 100,
                pageSizeOptions: [100, 500, 1000, 2000, 2500, 3000],
              }}
            />
          </>
        ) : (
          <div
            style={{
              backgroundColor: "#f5f5f5",
              border: "1px dashed #d9d9d9",
              fontWeight: "bold",
              height: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "4px",
            }}
          >
            No record(s) found
          </div>
        )}
      </div>
    </div>
  );
};

export default PendingBillPayment;